import React, { useEffect, useState, useRef } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { apiClient } from "../lib/api";
import { CheckCircle, XCircle, Spinner } from "@phosphor-icons/react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState({ status: "pending", error: null });
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current || !token) {
      if (!token) setState({ status: "error", error: "Missing token" });
      return;
    }
    ran.current = true;
    (async () => {
      try {
        await apiClient.post("/auth/verify-email", { token });
        setState({ status: "ok", error: null });
      } catch (err) {
        setState({ status: "error", error: err?.response?.data?.detail || "Verification failed" });
      }
    })();
  }, [token]);

  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center px-4 py-16 grid-bg">
      <div className="w-full max-w-md surface border border-white/10 p-10 text-center">
        {state.status === "pending" && (
          <>
            <Spinner size={40} className="mx-auto animate-spin text-primary-yellow" />
            <h1 className="font-heading text-3xl uppercase font-black mt-6">Verifying…</h1>
          </>
        )}
        {state.status === "ok" && (
          <>
            <CheckCircle size={56} weight="fill" className="mx-auto text-primary-yellow" />
            <h1 className="font-heading text-3xl uppercase font-black mt-6">Email Verified</h1>
            <p className="text-white/60 mt-3 text-sm">Welcome aboard. You can now make predictions.</p>
            <Link to="/fixtures" data-testid="verify-cta" className="mt-8 inline-block w-full bg-primary-yellow text-black uppercase tracking-[0.2em] font-bold py-4 text-sm hover:-translate-y-0.5 transition-transform">Go to Fixtures</Link>
          </>
        )}
        {state.status === "error" && (
          <>
            <XCircle size={56} weight="fill" className="mx-auto text-red-400" />
            <h1 className="font-heading text-3xl uppercase font-black mt-6">Verification Failed</h1>
            <p className="text-white/60 mt-3 text-sm">{state.error}</p>
            <Link to="/login" className="mt-8 inline-block w-full border border-white/20 uppercase tracking-[0.2em] font-bold py-4 text-sm hover:border-primary-yellow hover:text-primary-yellow transition-colors">Back to Login</Link>
          </>
        )}
      </div>
    </div>
  );
}
